import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import Home from "./pages/Home";
import Profil from "./pages/TentangKami/Profil";
import StrukturOrganisasi from "./pages/TentangKami/StrukturOrganisasi";
import VisiMisi from "./pages/TentangKami/VisiMisi";
import TentangP3H from "./pages/P3H/TentangP3H";
import PendaftaranP3H from "./pages/P3H/PendaftaranP3H";
import PeraturanPerundangan from "./pages/Dokumen/PeraturanPerundangan";
import PedomanPanduan from "./pages/Dokumen/PedomanPanduan";
import PendaftaranPenyelia from "./pages/PendaftaranPenyelia";
import DaftarAudit from "./pages/DaftarAudit";
import KalkulatorBiaya from "./pages/KalkulatorBiaya";
import Contact from "./pages/Contact";
import BeritaDetail from "./pages/BeritaDetail";
import Berita from "./pages/Berita";
import LayananDetail from "./pages/LayananDetail";
import ContentPage from "./pages/ContentPage";
import Login from "./pages/Admin/Login";
import AdminLayout from "./components/Admin/AdminLayout";
import Dashboard from "./pages/Admin/Dashboard";
import ContentManagement from "./pages/Admin/ContentManagement";
import SliderManagement from "./pages/Admin/SliderManagement";
import BeritaManagement from "./pages/Admin/BeritaManagement";
import LayananManagement from "./pages/Admin/LayananManagement";
import WelcomeManagement from "./pages/Admin/WelcomeManagement";
import ClientManagement from "./pages/Admin/ClientManagement";
import SettingsManagement from "./pages/Admin/SettingsManagement";
import JadwalPelatihan from "./pages/Admin/JadwalPelatihan";
import CalonPendamping from "./pages/Admin/CalonPendamping";
import PesertaPelatihan from "./pages/Admin/PesertaPelatihan";
import DaftarPendamping from "./pages/Admin/DaftarPendamping";
import LaporanKinerjaPendamping from "./pages/Admin/LaporanKinerjaPendamping";
import LaporanReferral from "./pages/Admin/LaporanReferral";
import DaftarTagihan from "./pages/Admin/DaftarTagihan";
import ProfilPendamping from "./pages/Admin/ProfilPendamping";
import ProfilPenyelia from "./pages/Admin/ProfilPenyelia";
import ContactManagement from "./pages/Admin/ContactManagement";
import MenuManagement from "./pages/Admin/MenuManagement";
import DaftarPengajuanPU from "./pages/Admin/DaftarPengajuanPU";
import DaftarPengajuan from "./pages/Admin/DaftarPengajuan";
import ProsesVerval from "./pages/Admin/ProsesVerval";
import LaporanHasilVerval from "./pages/Admin/LaporanHasilVerval";
import LaporanSHTerbit from "./pages/Admin/LaporanSHTerbit";
import CekStatusPembayaran from "./pages/Admin/CekStatusPembayaran";
import ChangePassword from "./pages/Admin/ChangePassword";
import DetailRegistrasi from "./pages/Admin/DetailRegistrasi";
import DetailTagihan from "./pages/Admin/DetailTagihan";
import PengajuanSHCekPengajuan from "./pages/Admin/PengajuanSHCekPengajuan";
import PengajuanSHCekPembayaran from "./pages/Admin/PengajuanSHCekPembayaran";
import LpkDataPelatihanPenyeliaHalal from "./pages/Admin/LpkDataPelatihanPenyeliaHalal";
import LpkDataPelatihanAuditorHalal from "./pages/Admin/LpkDataPelatihanAuditorHalal";
import LpkDataPelatihanJphLainnya from "./pages/Admin/LpkDataPelatihanJphLainnya";
import LpkInquiry from "./pages/Admin/LpkInquiry";
import LpkInvoice from "./pages/Admin/LpkInvoice";
import DaftarPengajuanReguler from "./pages/Admin/DaftarPengajuanReguler";
import DetailReguler from "./pages/Admin/DetailReguler";
import Rekapitulasi from "./pages/Admin/Rekapitulasi";
import DaftarInvoice from "./pages/Admin/DaftarInvoice";
import DetailInvoiceReguler from "./pages/Admin/DetailInvoiceReguler";
import EntriCalonPeserta from "./pages/Admin/EntriCalonPeserta";
import PesertaDaftarCalon from "./pages/Admin/PesertaDaftarCalon";
import PesertaDaftarPeserta from "./pages/Admin/PesertaDaftarPeserta";
import PesertaPenerbitanSertifikat from "./pages/Admin/PesertaPenerbitanSertifikat";
import PesertaDaftarSertifikatTerbit from "./pages/Admin/PesertaDaftarSertifikatTerbit";
import PesertaInquiry from "./pages/Admin/PesertaInquiry";
import JadwalPelatihanR41 from "./pages/Admin/JadwalPelatihanR41";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route
                path="/*"
                element={
                  <>
                    <Header />
                    <main>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/profil" element={<Profil />} />
                        <Route
                          path="/struktur-organisasi"
                          element={<StrukturOrganisasi />}
                        />
                        <Route path="/visi-misi" element={<VisiMisi />} />
                        <Route path="/tentang-p3h" element={<TentangP3H />} />
                        <Route
                          path="/pendaftaran-p3h"
                          element={<PendaftaranP3H />}
                        />
                        <Route
                          path="/peraturan-perundangan"
                          element={<PeraturanPerundangan />}
                        />
                        <Route
                          path="/pedoman-panduan"
                          element={<PedomanPanduan />}
                        />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/berita" element={<Berita />} />
                        <Route
                          path="/berita/:slug"
                          element={<BeritaDetail />}
                        />
                        <Route
                          path="/layanan/:id"
                          element={<LayananDetail />}
                        />
                        {/* Route generik untuk menu bertipe content */}
                        <Route
                          path="/halaman/:jenis"
                          element={<ContentPage />}
                        />
                        <Route
                          path="/pendaftaran-penyelia"
                          element={<PendaftaranPenyelia />}
                        />
                        <Route path="/daftar-audit" element={<DaftarAudit />} />
                        <Route
                          path="/kalkulator-biaya"
                          element={<KalkulatorBiaya />}
                        />
                      </Routes>
                    </main>
                    <Footer />
                  </>
                }
              />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="dashboard" element={<Dashboard />} />
                <Route
                  path="profil"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.47", "R.45"]}>
                      <ProfilPendamping />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="profil-penyelia"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.48"]}>
                      <ProfilPenyelia />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="content"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <ContentManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="slider"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <SliderManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="berita"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <BeritaManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="layanan"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <LayananManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="welcome"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <WelcomeManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="client"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <ClientManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="settings"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <SettingsManagement />
                    </RoleProtectedRoute>
                  }
                />
                {/* Pelatihan Pendamping Routes */}
                <Route
                  path="pelatihan/jadwal"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.40", "R.41", "R.1"]}>
                      <JadwalPelatihan />
                    </RoleProtectedRoute>
                  }
                />
                {/* Jadwal Pelatihan R.41 Routes */}
                <Route
                  path="pelatihan/jadwal-r41"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <JadwalPelatihanR41 />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pelatihan/calon-pendamping"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <CalonPendamping />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pelatihan/peserta"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <PesertaPelatihan />
                    </RoleProtectedRoute>
                  }
                />
                {/* Pendamping Routes */}
                <Route
                  path="pendamping/daftar"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <DaftarPendamping />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pendamping/laporan-kinerja"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <LaporanKinerjaPendamping />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pendamping/laporan-referral"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <LaporanReferral />
                    </RoleProtectedRoute>
                  }
                />
                {/* Informasi Tagihan Routes */}
                <Route
                  path="tagihan/daftar"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <DaftarTagihan />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="tagihan/detail/:token"
                  element={<DetailTagihan />}
                />
                <Route
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <ContactManagement />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="menu"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1", "R.2"]}>
                      <MenuManagement />
                    </RoleProtectedRoute>
                  }
                />
                {/* Pengajuan Sertifikat Halal Routes - R.45 */}
                <Route
                  path="sertifikat/daftar-pengajuan-pu"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.45"]}>
                      <DaftarPengajuanPU />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="sertifikat/proses-verval"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.45"]}>
                      <ProsesVerval />
                    </RoleProtectedRoute>
                  }
                />
                {/* Laporan Routes - R.45 */}
                <Route
                  path="laporan/hasil-verval"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.45"]}>
                      <LaporanHasilVerval />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="laporan/sh-terbit"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.45"]}>
                      <LaporanSHTerbit />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="laporan/cek-status-pembayaran"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.45"]}>
                      <CekStatusPembayaran />
                    </RoleProtectedRoute>
                  }
                />
                {/* Pengajuan SH Routes - selevel dengan Pendamping */}
                <Route
                  path="pengajuan-sh/daftar-pengajuan"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <DaftarPengajuan />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pengajuan-sh/cek-pengajuan"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <PengajuanSHCekPengajuan />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pengajuan-sh/cek-pembayaran"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      <PengajuanSHCekPembayaran />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="pengajuan-sh/rekap-by-pendamping"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.1"]}>
                      {React.createElement(
                        require("./pages/Admin/RekapByPendamping").default,
                      )}
                    </RoleProtectedRoute>
                  }
                />
                {/* LPK Routes */}
                <Route
                  path="lpk/data-pelatihan-penyelia-halal"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <LpkDataPelatihanPenyeliaHalal />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="lpk/data-pelatihan-auditor-halal"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <LpkDataPelatihanAuditorHalal />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="lpk/data-pelatihan-jph-lainnya"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <LpkDataPelatihanJphLainnya />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="lpk/inquiry"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <LpkInquiry />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="lpk/invoice"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <LpkInvoice />
                    </RoleProtectedRoute>
                  }
                />
                {/* Peserta Pelatihan Routes - R.41 */}
                <Route
                  path="peserta/entri-calon"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <EntriCalonPeserta />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="peserta/daftar-calon"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <PesertaDaftarCalon />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="peserta/daftar-peserta"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <PesertaDaftarPeserta />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="peserta/penerbitan-sertifikat"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <PesertaPenerbitanSertifikat />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="peserta/daftar-sertifikat-terbit"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <PesertaDaftarSertifikatTerbit />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="peserta/inquiry"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.41"]}>
                      <PesertaInquiry />
                    </RoleProtectedRoute>
                  }
                />
                {/* Pengajuan Reguler Routes - R.2, R.5 */}
                <Route
                  path="reguler/daftar-pengajuan"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.2", "R.5"]}>
                      <DaftarPengajuanReguler />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="reguler/rekapitulasi"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.2", "R.5"]}>
                      <Rekapitulasi />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="reguler/detail/:id_reg"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.2", "R.5"]}>
                      <DetailReguler />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="reguler/daftar-invoice"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.2", "R.5"]}>
                      <DaftarInvoice />
                    </RoleProtectedRoute>
                  }
                />
                <Route
                  path="reguler/detail-invoice/:token"
                  element={
                    <RoleProtectedRoute allowedRoles={["R.2", "R.5"]}>
                      <DetailInvoiceReguler />
                    </RoleProtectedRoute>
                  }
                />
                {/* Change Password - Available to all authenticated users */}
                <Route path="ganti-password" element={<ChangePassword />} />
                {/* Detail Registrasi - inside admin layout */}
                <Route
                  path="pendamping/detail-registrasi/:token"
                  element={<DetailRegistrasi />}
                />
              </Route>
            </Routes>
          </div>
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
